import _jsx from "@babel/runtime/helpers/jsx";
var _strong, _strong2, _strong3, _span;
import PropTypes from 'prop-types';
import React from 'react';
import { priceIndicator } from 'axl-config';
import { Glyphicon, Popover, OverlayTrigger, withOverlayTrigger } from 'reaxl';

/**
 *  FraudReport displays a trigger and will open a Fraud Report modal
 *
 */
function FilterPriceDisclaimer(_ref) {
  let {
    options = [],
    popoverPosition,
    popoverTriggerEvent
  } = _ref;
  const {
    disclaimer
  } = priceIndicator;

  // Function handles which disclaimer message to show on tool tip
  const hasExceptional = options.some(option => option.label.includes('Exceptional Price'));
  const popover = /*#__PURE__*/_jsx(Popover, {
    id: "priceDisclaimer",
    className: "text-gray-base"
  }, void 0, /*#__PURE__*/_jsx("ul", {
    className: "list-unstyled"
  }, void 0, hasExceptional && /*#__PURE__*/_jsx("li", {}, void 0, _strong || (_strong = /*#__PURE__*/_jsx("strong", {}, void 0, "Exceptional Price ")), disclaimer.exceptionalDisclaimer), /*#__PURE__*/_jsx("li", {}, void 0, _strong2 || (_strong2 = /*#__PURE__*/_jsx("strong", {}, void 0, "Great Price ")), disclaimer.greatDisclaimer), /*#__PURE__*/_jsx("li", {}, void 0, _strong3 || (_strong3 = /*#__PURE__*/_jsx("strong", {}, void 0, "Good Price ")), disclaimer.goodDisclaimer)), disclaimer.genericDisclaimer);
  return /*#__PURE__*/_jsx("div", {
    className: "row"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "col-xs-12 padding-top-1"
  }, void 0, /*#__PURE__*/_jsx(OverlayTrigger, {
    trigger: popoverTriggerEvent,
    placement: popoverPosition,
    rootClose: true,
    overlay: popover
  }, void 0, _span || (_span = /*#__PURE__*/_jsx("span", {
    className: "text-link margin-horizontal-1",
    id: "dealInfo"
  }, void 0, /*#__PURE__*/_jsx(Glyphicon, {
    glyph: "info"
  }), ' ', "More info")))));
}
export default withOverlayTrigger({
  defaultPosition: 'bottom',
  top: ['sm'],
  right: ['xs', 'landscape']
})(FilterPriceDisclaimer);